<template>
  <slider-wins />

  <the-nav />

  <div class="main-wrap">
    <winners />

    <div class="wins-table-wrap">
      <div class="wins-title-fl">
        <div class="wins-title">· Топ 10 игроков ·</div>
        <div class="wins-togle">
          <div :class="`wins-togle-m ${!this.tabWeek ? 'wins-togle-active' : ''}`" @click="this.changeTab(false)">
            Месяц
          </div>
          <div
            :class="`wins-togle-line ${this.tabWeek ? 'wins-togle-line-right' : ''}`"
            @click="this.changeTab(!this.tabWeek)"
          >
            <div class="wins-togle-line-dot"></div>
          </div>
          <div :class="`wins-togle-w ${this.tabWeek ? 'wins-togle-active' : ''}`" @click="this.changeTab(true)">
            Неделя
          </div>
        </div>
      </div>
      <div class="wins-table-tabs">
        <div class="wins-table-tabs-m">
          <table class="wins-table">
            <thead>
              <tr>
                <td>
                  <img :src="require('@/assets/images/tournament-wins-table1.svg')" alt="" />
                  Игра
                </td>
                <td>
                  <img :src="require('@/assets/images/tournament-wins-table2.svg')" alt="" />
                  Логин
                </td>
                <td>
                  <img :src="require('@/assets/images/tournament-wins-table5.svg')" alt="" />
                  Дата
                </td>
                <td>
                  <img :src="require('@/assets/images/tournament-wins-table6.svg')" alt="" />
                  Сумма выигрыша
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="winner in winners" :key="winner.id">
                <td>
                  <div class="twt-name" :set="(winGame = gameBySlug(winner.gameSlug))">
                    <img :src="winGame?.icon" :title="winGame?.title" />
                    <span>{{ winGame?.title }}</span>
                  </div>
                </td>
                <td>
                  {{ winner.username }}
                  <!--                  <div class="tournament-wins-table-online"></div>-->
                </td>
                <td>{{ format(new Date(winner.date), 'dd.MM.yyyy HH:mm') }}</td>
                <td>
                  <div class="tournaments-table-win-line">{{ n(winner.win) }} ₽</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="wins-table-text">
        Игровой клуб Миллионъ полностью открыт для своих посетителей и поэтому в режиме онлайн Вы можете видеть все
        максимальные выигрыши клуба за последние 7 дней или месяц. И помни, на месте этих игроков может быть твой логин!
        <br /><br />
        Играй и выигрывай крупные суммы и ищи свой логин в таблице Максимальных Выигрышей за последнюю неделю или месяц!
      </div>
    </div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import PlayLine from '@/components/PlayLine'
import SliderWins from '@/components/sliders/SliderWins'
import TheNav from '@/components/TheNav'
import BonusesLine from '@/components/BonusesLine.vue'
import Winners from '@/components/Winners'
import { mapGetters } from 'vuex'
import { FETCH_WINNERS } from '@/store/actions.type'
import { useI18n } from 'vue-i18n'
import { format } from 'date-fns'

export default {
  name: 'Wins',
  components: { Winners, BonusesLine, TheNav, PlayLine, SliderWins },
  data() {
    return {
      tabWeek: false,
      format,
      winners: [],
    }
  },
  setup() {
    const { t, n } = useI18n()

    return { t, n }
  },
  computed: {
    ...mapGetters(['winnersWeek', 'winnersMonth', 'gameBySlug']),
  },
  created() {
    this.changeTab(false)
  },
  methods: {
    changeTab(tabWeek) {
      this.tabWeek = tabWeek
      if (tabWeek) {
        this.$store.dispatch(FETCH_WINNERS, { period: 'week' }).then(() => {
          this.winners = this.winnersWeek
        })
      } else {
        this.$store.dispatch(FETCH_WINNERS, { period: 'month' }).then(() => {
          this.winners = this.winnersMonth
        })
      }
    },
  },
}
</script>

<style scoped></style>
